<section class="container-fluid distributor_recharge employee_dash mb-5">
  <div *ngIf="businessDetails">
    <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'Company Details' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="parent-container">
                  <!-- <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label for="">{{'ANPI Number'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.anpi_no}}</p>
                    </div>
                  </div> -->
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº NIF (DGI)'|translate}}&nbsp;:</label></div>
                      <p class="text-center">{{businessDetails.nif}}</p>
                    </div>
                  </div>
                  <!-- <div class="child-container full-width">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº RCCM'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.rccm}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº VOL'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.vol}}</p>
                    </div>
                  </div> -->
                  <!-- <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº FOLIO'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.folio}}</p>
                    </div>
                  </div> -->
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº CNSS'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.cnss}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nº CNAMGS'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.cnamgs}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Company Type'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.legal_status}}</p>
                    </div>
                  </div>
                  <div class="child-container full-width">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Dénomination sociale'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.company_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Mobile'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.mobile}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Email Address'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.email}}</p>
                    </div>
                  </div>
                  <!-- <div class="child-container full-width">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nom Commercial'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize ">{{businessDetails.trade_name}}</p>
                    </div>
                  </div> -->
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Acronym'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.acrononym}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'CNSS and CNAMGS Status' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="">
                  <form [formGroup]="cnssCnamgsForm">

                    <div class="radio-box-section">
                      <div class="radio-box-container flex-row justify-content-between">
                        <p class="radio-box-title">{{'Have you registered in CNSS and CNAMGS ?' | translate}}</p>
                        <div class="checkbox-group">
                          <mat-checkbox formControlName="is_cnamgs" class="mat-checkbox-btn">
                            <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div> 
                          </mat-checkbox>
                          <mat-checkbox formControlName="is_cnss" class="mat-checkbox-btn">
                            <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div>  
                          </mat-checkbox>
                        </div>
                        <button type="submit" class="btn btn-medium" (click)="onSubmitCnssCnamgs()" [disabled]="isSubmitted">{{'Submit' | translate}}</button>
                      </div>
                    </div>
                    
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'Business Location' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="parent-container">
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label for="">{{'Region'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.business_region_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'City'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.business_city_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'District'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.business_district_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Neighbourhood'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.business_neighborhood_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Place called'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.place}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Street'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.street}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Post box'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.business_post_box}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Locality (Village)'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.locality}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'Contact Details' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="parent-container">
                 
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Téléphone'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.telephone}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Email Address'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.email}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Website'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.website}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Fax'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.fax}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'Details of Business Owner' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="parent-container">
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label for="">{{'First name2'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.first_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Last name2'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.last_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Date of Birth' | translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.birth_date}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Birthplace'| translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.birth_place}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Country'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_country_id}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Nationality'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_nationality_id}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Region'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_region_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'City'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_city_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Neighbourhood'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_neighbourhood_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'District'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_district_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Street'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_street_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'N° Porte'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.owner_door_no}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Place called'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_place}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Localité'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.owner_locality}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'ID proof'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.id_proof}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'ID proof number'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.id_number}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Phone number'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.phone_no}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Post box'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.owner_post_box}}</p>
                    </div>
                  </div>
                 
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Personal email'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.owner_email}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="grid-col2">
      <div class="col_2 bgStyle">
        <div class="company_details card_gr">
          <div class="head">
            <h5 class="text-md">{{'Additional Details' | translate}}</h5>
          </div>
          <div class="profile-info">
            <div class="first_section">
              <div class="profile-info">
                <div class="parent-container">
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Administration name'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.administration_name}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Local community'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.local_community}}</p>
                    </div>
                  </div>
            
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Department'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.department}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Municipality'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.municipality}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Township'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.township}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Takeover date'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.takeover_date}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Former business manager'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.fax}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Employer Plan'|translate}}&nbsp;:</label></div>
                      <p class="text-center txt-capitalize">{{businessDetails.employer_plan}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Tax'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.tax}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'SEEG subscription number'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.seeg_subscription_no}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div>
                      <p class="numberOfworkersinterns">{{'Nombre de travailleurs'|translate}}</p>
                    </div>
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Men'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.worker_men}}</p>
                    </div>
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Women'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.worker_women}}</p>
                    </div>
                  </div>
                  <div class="child-container">
                    <div>
                      <p class="numberOfworkersinterns">{{'Number of interns' | translate}}</p>
                    </div>
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Men'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.interns_men_no}}</p>
                    </div>
                    <div class="txt-container">
                      <div class="label-txt-container"><label>{{'Women'|translate}}&nbsp;:</label></div>
                      <p class="text-center ">{{businessDetails.interns_women_no}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
  <!-- <div class="grid-col2" *ngIf="bankDetails">
        <div class="col_2 bgStyle">
            <div class="company_details card_gr">
                <div class="head">
                    <h5 class="text-md">{{'Bank Details' | translate}}</h5>
                    <hr class="mt-4">
                </div>
                <div class="profile-info"  >
                    <div class="first_section">
                        <div class="profile-info">
                            <div class="parent-container">
                                <div class="child-container">
                                    <div class="txt-container">
                                        <div class="label-txt-container"><label>{{'Account no'|translate}}&nbsp;:</label></div>
                                        <p class="text-center ">{{bankDetails.ac_number}}</p>
                                    </div>
                                </div>
                                <div class="child-container">
                                    <div class="txt-container">
                                        <div class="label-txt-container"><label>{{'Account name'|translate}}&nbsp;: </label></div>
                                        <p class="text-center ">{{bankDetails.account_name}}</p>
                                    </div>
                                </div>
                                <div class="child-container">
                                    <div class="txt-container">
                                        <div class="label-txt-container"><label>{{'Bank name'|translate}}&nbsp;: </label></div>
                                        <p class="text-center ">{{bankDetails.bank_name}}</p>
                                    </div>
                                </div>
                                <div class="child-container">
                                    <div class="txt-container">
                                        <div class="label-txt-container"><label>{{'RIB key '|translate}}&nbsp;: </label></div>
                                        <p class="text-center ">{{bankDetails.tax}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div> -->
</section>
<!-- <section class="distributor_recharge employee_dash container-fluid">
    
</section>
<section class="distributor_recharge employee_dash container-fluid">
    
</section>
<section class="distributor_recharge employee_dash container-fluid">
    
</section> -->
